import { useEffect, useState } from "react";
//#region src/hooks/useBrowserFocus.ts
var hasFocus = () => typeof document !== "undefined" && document.hasFocus();
var useBrowserFocus = () => {
	const [focused, setFocused] = useState(hasFocus);
	useEffect(() => {
		setFocused(hasFocus());
		const onFocus = () => setFocused(true);
		const onBlur = () => setFocused(false);
		window.addEventListener("focus", onFocus);
		window.addEventListener("blur", onBlur);
		return () => {
			window.removeEventListener("focus", onFocus);
			window.removeEventListener("blur", onBlur);
		};
	}, []);
	return focused;
};
//#endregion
export { useBrowserFocus };

//# sourceMappingURL=useBrowserFocus.js.map